<template>
    <div class="modal-content">
        <p>
            <span class="heading-1 form-heading">
                {{ opposesCount }}
                {{ opposesCount == 1 ? 'Oppose' : 'Opposes' }}
            </span>
            <span class="heading-4 form-heading" @click.prevent="dismissModal" style="cursor: pointer; margin-left: 40px">X</span>
        </p>
        <transition name="fade" mode="out-in">
            <div>
                <transition-group name="feed-fade">
                    <CpOpposesProfileItem v-for="oppose in opposes" :key="oppose.id" :data="oppose" />
                </transition-group>
                <transition name="feed-fade">
                    <infinite-loading @infinite="loadOpposesProfiles" v-margin="1">
                        <div slot="spinner">
                            <div class="heading-4"><vue-simple-spinner v-margin="1" />Loading opposes...</div>
                        </div>
                        <div slot="no-more">
                            <div class="heading-4">That's all!</div>
                        </div>
                        <div slot="no-results">
                            <div class="heading-4">No opposes!</div>
                        </div>
                    </infinite-loading>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
import { getLobbies } from '../api/lobbying';

export default {
    data() {
        return {
            opposesPage: 0,
            opposes: [],
        };
    },

    methods: {
        dismissModal() {
            this.$emit('close');
        },
        loadOpposesProfiles($state) {
            if (this.type == 'officials') {
                getLobbies(this.id, { type_lobby: this.lobbyType, page: this.opposesPage })
                    .then((response) => {
                        if (response.lobbies.length) {
                            this.opposes = this.opposes.concat(response.lobbies);
                            this.opposesPage += 1;
                            $state.loaded();
                        } else {
                            $state.complete();
                        }
                    })
                    .catch((error) => {
                        $state.complete();
                        console.warn(error);
                    });
            }
        },
    },

    props: {
        type: String,
        opposesCount: [Number, String],
        id: [String, Number],
        lobbyType: String,
    },

    directives: {
        margin: require('../directives/margins').margin,
        marginBottom: require('../directives/margins').marginBottom,
        marginTop: require('../directives/margins').marginTop,
    },

    components: {
        CpButton: require('../button'),
        CpImage: require('../image'),
        CpOpposesProfileItem: require('./OpposesProfileItem').default,
        VueSimpleSpinner: require('../vue-simple-spinner').default,
        InfiniteLoading: require('vue-infinite-loading').default,
    },
};
</script>

<style scoped>
.modal-content {
    max-width: 460px;
    padding: 40px 80px 30px;
    text-align: center;
}
@media (max-width: 768px) {
    .modal-content {
        padding: 20px 40px;
    }
}
/* transition styles */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.4s ease-in-out;
}
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
